import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	unableToLoadCommentsTitle: {
		id: 'object-comments.error.unable.to.load.comments',
		defaultMessage: 'Unable to load comments',
		description:
			'The title of the flag shown to a user that says their comments could not be loaded',
	},
	networkError: {
		id: 'object-comments.error.network',
		defaultMessage:
			'A network error was encountered when loading comments. Please try refreshing the page.',
		description: 'A message explaining a network error occurred',
	},
	viewNotPermitted: {
		id: 'object-comments.error.view.not.permitted',
		defaultMessage:
			'Your permission settings don’t allow you to view comments on this page. Check with your administrator if you need this ability.',
		description: "A message informing the user they don't have permissions to view page comments",
	},
	unexpectedError: {
		id: 'object-comments.error.unexpected',
		defaultMessage: 'Something went wrong when loading comments on this page.',
		description: 'A message explaining an unexpected error occurred',
	},
});
